import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const UpcomingEventsSkeleton = () => {
  return (
    <VStack width="100%">
      <HStack justifyContent="space-between">
        <SkeletonLoader height={20} width={220} borderRadius="2" />
        <HStack gap={2}>
          <SkeletonLoader height={32} width={32} borderRadius="2" />
          <SkeletonLoader height={32} width={32} borderRadius="2" />
        </HStack>
      </HStack>

      <HStack py={4} gap={2} overflow="scroll">
        <EventCardSkeleton featured />
        <EventCardSkeleton featured />
      </HStack>
      <HStack width="100%" justifyContent="center" gap={1}>
        <SkeletonLoader height={6} width={6} borderRadius="2" />
        <SkeletonLoader height={6} width={6} borderRadius="2" />
        <SkeletonLoader height={6} width={6} borderRadius="2" />
      </HStack>
      <VStack mt={8}>
        <Box height={32} justifyContent="center">
          <SkeletonLoader height={20} width={220} borderRadius="2" />
        </Box>
        <Box mt={5} height={24} justifyContent="center">
          <SkeletonLoader height={16} width={100} borderRadius="2" />
        </Box>
      </VStack>
      <VStack gap={4} mt={4} overflow="scroll">
        <EventCardSkeleton />
        <EventCardSkeleton />
        <EventCardSkeleton />
      </VStack>
    </VStack>
  );
};

export const EventCardSkeleton = ({
  featured = false,
}: {
  featured?: boolean;
}) => {
  return (
    <Box
      borderRadius="4"
      borderWidth={4}
      borderColor="grayscale-400"
      width={featured ? 296 : "100%"}
      height={featured ? 204 : 108}
      p={3}
      gap={2}
      flexDirection={featured ? "column" : "row"}
      alignItems={featured ? "flex-start" : "center"}
    >
      <SkeletonLoader height={84} width={153} borderRadius="2" />
      <VStack gap={2}>
        <SkeletonLoader height={8} width={80} borderRadius="0.5" />
        <SkeletonLoader height={12} width={220} borderRadius="0.5" />
        <HStack gap={4}>
          <HStack gap={2} alignItems="center">
            <SkeletonLoader height={12} width={12} borderRadius="0.5" />
            <SkeletonLoader height={12} width={64} borderRadius="0.5" />
          </HStack>
          <HStack gap={2}>
            <SkeletonLoader height={12} width={12} borderRadius="0.5" />
            <SkeletonLoader height={12} width={64} borderRadius="0.5" />
          </HStack>
        </HStack>
        <SkeletonLoader height={12} width={50} borderRadius="0.5" />
      </VStack>
    </Box>
  );
};
